import { CalculationEngineMonthlyValueOverrides, FarmerMarginCalculatorModel, RunCalculationEngineResponse } from '../../../../../../Generated/Raven-Demeter';
import { TrackingEvent } from '../../../../../Services/Tracking/TrackingService';
import { HideGroup, MarginCompositeModel, TabEventKeyType } from '../../../RiskDefinitions';
import MarginDataRow from '../MarginDataRow';
import MarginInputRow from '../MarginInputRow';
import styles from '../MarginInputsTable.module.scss';

interface IMarginInputsTableCostDataProps {
    getFarmerMarginCalculatorCompositeRowsModel: MarginCompositeModel[];
    runCalculationEngineResponse: RunCalculationEngineResponse;
    savedFarmerMarginCalculator?: FarmerMarginCalculatorModel;
    hideGroup: HideGroup;
    runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null;
    setRunMonthlyValueOverrides: (runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null) => void;
    handleGridTabNavigation: (columnIndex: number, rowIndex: number, direction: TabEventKeyType) => void;
    track: TrackingEvent;
}

const MarginInputsTableCostData: React.FC<IMarginInputsTableCostDataProps> = (props: IMarginInputsTableCostDataProps) => {
    const firstRowModel = props.getFarmerMarginCalculatorCompositeRowsModel[0];
    const showCostTotalPriceChildren = props.hideGroup[firstRowModel.costTotalPrice.variableName] === false;
    const topLevelBackground = styles.margin_inputs_table_top_level_background;
    const level1ChildBackground = styles.margin_inputs_table_level_1_background;
    const level2ChildBackground = styles.margin_inputs_table_level_2_background;
    const level3ChildBackground = styles.margin_inputs_table_level_3_background;

    return (
        <>
            {showCostTotalPriceChildren &&
                firstRowModel.costTotalPrice.children!.map((child) => {
                    const showGroup = props.hideGroup[child.variableName] === false;
                    const level1Parent = [firstRowModel.costTotalPrice.variableName];

                    const finalRow = (
                        <MarginInputRow
                            className={!showGroup ? level1ChildBackground : level2ChildBackground}
                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                            ancestors={level1Parent}
                            hideGroup={props.hideGroup}
                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                            disabled={showGroup}
                            fieldName={child.variableName}
                            handleGridTabNavigation={props.handleGridTabNavigation}
                            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                            track={props.track}
                        />
                    );

                    if (showGroup) {
                        return (
                            <>
                                {child.children?.map((secondLevelChild) => {
                                    const combinationVariableName =
                                        child.children?.find((x) => x.combinedWith?.find((y) => y.variableName === secondLevelChild.variableName))
                                            ?.variableName ?? '';
                                    const showSecondaryGroup =
                                        props.hideGroup[secondLevelChild.variableName] === false || props.hideGroup[combinationVariableName] === false;

                                    const level2Parents = [child.variableName, ...(child.combinedWith?.map((y) => y.variableName) ?? [])];
                                    const secondaryRow = secondLevelChild.isReadOnly ? (
                                        <MarginDataRow
                                            className={
                                                props.hideGroup[secondLevelChild.variableName] !== false && props.hideGroup[combinationVariableName] !== false
                                                    ? level2ChildBackground
                                                    : level3ChildBackground
                                            }
                                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                                            fieldName={secondLevelChild.variableName}
                                        />
                                    ) : (
                                        <MarginInputRow
                                            className={
                                                props.hideGroup[secondLevelChild.variableName] !== false && props.hideGroup[combinationVariableName] !== false
                                                    ? level2ChildBackground
                                                    : level3ChildBackground
                                            }
                                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                            ancestors={[...level1Parent, ...level2Parents]}
                                            hideGroup={props.hideGroup}
                                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                                            disabled={showSecondaryGroup}
                                            fieldName={secondLevelChild.variableName}
                                            handleGridTabNavigation={props.handleGridTabNavigation}
                                            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                                            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                                            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                                            track={props.track}
                                        />
                                    );
                                    if (showSecondaryGroup) {
                                        return (
                                            <>
                                                {secondLevelChild.children?.map((thirdLevelChild) => {
                                                    const thirdLeveGroupIsHidden = props.hideGroup[thirdLevelChild.variableName] === false;

                                                    if (thirdLevelChild.isReadOnly) {
                                                        return (
                                                            <MarginDataRow
                                                                className={styles.margin_inputs_table_level_3_background}
                                                                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                                                runCalculationEngineResponse={props.runCalculationEngineResponse}
                                                                fieldName={thirdLevelChild.variableName}
                                                            />
                                                        );
                                                    }
                                                    return (
                                                        <MarginInputRow
                                                            className={styles.margin_inputs_table_level_3_background}
                                                            getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                                                            ancestors={[
                                                                ...level1Parent,
                                                                ...level2Parents,
                                                                secondLevelChild.variableName,
                                                                ...(secondLevelChild.combinedWith?.map((x) => x.variableName) ?? []),
                                                            ]}
                                                            hideGroup={props.hideGroup}
                                                            runCalculationEngineResponse={props.runCalculationEngineResponse}
                                                            disabled={thirdLeveGroupIsHidden}
                                                            fieldName={thirdLevelChild.variableName}
                                                            handleGridTabNavigation={props.handleGridTabNavigation}
                                                            runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                                                            setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                                                            savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                                                            track={props.track}
                                                        />
                                                    );
                                                })}
                                                {secondaryRow}
                                            </>
                                        );
                                    }

                                    return secondaryRow;
                                })}

                                {finalRow}
                            </>
                        );
                    }

                    return finalRow;
                })}

            <MarginInputRow
                className={showCostTotalPriceChildren ? level1ChildBackground : topLevelBackground}
                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                hideGroup={props.hideGroup}
                disabled={showCostTotalPriceChildren}
                runCalculationEngineResponse={props.runCalculationEngineResponse}
                fieldName={firstRowModel.costTotalPrice.variableName}
                handleGridTabNavigation={props.handleGridTabNavigation}
                runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                track={props.track}
            />
        </>
    );
};

export default MarginInputsTableCostData;
